import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getByIdEventAkademik = createAsyncThunk("eventAkademik/getByIdEventAkademik",
async(val) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/event/kalender/${val}`
        const response = await jwtAuthAxios.get(url)
        return response.data;
    } catch(response){
        throw response
    }
});

export const findAllEventAkademik = createAsyncThunk("eventAkademik/findAllEventAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/event/kalender`
            const response = await jwtAuthAxios.get(url)
            return response.data;
        } catch(response){
            throw response
        }
    });

export const saveEventAkademik = createAsyncThunk("eventAkademik/saveEventAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/event/kalender`
            const response = await jwtAuthAxios.post(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });

export const updateEventAkademik = createAsyncThunk("eventAkademik/updateEventAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/event/kalender`
            const response = await jwtAuthAxios.put(url,val);
            return response.data;
        } catch(response){
            throw response
        }
    });

export const deleteEventAkademik = createAsyncThunk("eventAkademik/deleteEventAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/event/kalender/${val}`
            const response = await jwtAuthAxios.delete(url);
            return response.data;
        } catch(response){
            throw response
        }
    });


const initialState = {
    loadingEA: false,
    dataEa: {},
    dataListEa: [],
}

const eventAkademikSlice = createSlice({
    name:"eventAkademik",
    initialState: initialState,
    extraReducers: (builder) => {
    builder
        .addCase(getByIdEventAkademik.pending, (state) => {
            state.loadingEA = true;
        })
        .addCase(getByIdEventAkademik.fulfilled, (state, action) => {
            state.dataEa = action.payload;
            state.loadingEA = false;
        })
        .addCase(getByIdEventAkademik.rejected, (state, action) => {
            state.loadingEA = false;
        })
    builder
        .addCase(findAllEventAkademik.pending, (state) => {
            state.loadingEA = true;
        })
        .addCase(findAllEventAkademik.fulfilled, (state, action) => {
            state.dataListEa = action.payload;
            state.loadingEA = false;
        })
        .addCase(findAllEventAkademik.rejected, (state, action) => {
            state.loadingEA = false;
        })
    builder
        .addCase(saveEventAkademik.pending, (state) => {
            state.loadingEA = true;
        })
        .addCase(saveEventAkademik.fulfilled, (state, action) => {
            state.dataEa = action.payload;
            state.loadingEA = false;
        })
        .addCase(saveEventAkademik.rejected, (state, action) => {
            state.loadingEA = false;
        })
    builder
        .addCase(updateEventAkademik.pending, (state) => {
            state.loadingEA = true;
        })
        .addCase(updateEventAkademik.fulfilled, (state, action) => {
            state.dataEa = action.payload;
            state.loadingEA = false;
        })
        .addCase(updateEventAkademik.rejected, (state, action) => {
            state.loadingEA = false;
        })

    builder
        .addCase(deleteEventAkademik.pending, (state) => {
            state.loadingEA = true;
        })
        .addCase(deleteEventAkademik.fulfilled, (state, action) => {
            state.dataEa = action.payload;
            state.loadingEA = false;
        })
        .addCase(deleteEventAkademik.rejected, (state, action) => {
            state.loadingEA = false;
        })
    }
})
export const eventAkademikSelector = (state) => state.eventAkademik;
export default eventAkademikSlice.reducer;